import { keyConst } from '@/constants';

import { scheduleTokenRefresh, stopTokenRefresh } from '@/utils/tokenRefresh';

export const persistAuthenticatedSession = (token: string, rememberMe?: boolean): void => {
  localStorage.setItem(keyConst.userToken, token);
  if (rememberMe !== undefined) {
    localStorage.setItem(keyConst.rememberMe, String(rememberMe));
  }
  scheduleTokenRefresh(token);
};

export const clearAuthenticatedSession = (): void => {
  stopTokenRefresh();
  localStorage.removeItem(keyConst.userToken);
  localStorage.removeItem(keyConst.rememberMe);
};
